import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useState,
} from 'react';

/**
 * Lightweight cross-component signal that lets the automation banner's
 * "Update Budget" CTA scroll to the Spend & Cost analytics card and
 * auto-open the budget target popover, without either component needing
 * to know about the other directly.
 */
type BudgetTargetSignalContextType = {
  budgetTargetOpenSignal: number;
  requestBudgetTargetOpen: () => void;
};

const BudgetTargetSignalContext = createContext<
  BudgetTargetSignalContextType | undefined
>(undefined);

export function BudgetTargetSignalProvider({ children }: PropsWithChildren) {
  const [budgetTargetOpenSignal, setBudgetTargetOpenSignal] = useState(0);

  const requestBudgetTargetOpen = useCallback(() => {
    setBudgetTargetOpenSignal(Date.now());
  }, []);

  return (
    <BudgetTargetSignalContext.Provider
      value={{ budgetTargetOpenSignal, requestBudgetTargetOpen }}
    >
      {children}
    </BudgetTargetSignalContext.Provider>
  );
}

export function useBudgetTargetSignal() {
  const context = useContext(BudgetTargetSignalContext);

  if (!context) {
    throw new Error(
      'useBudgetTargetSignal must be used within a BudgetTargetSignalProvider',
    );
  }

  return context;
}
